import { IAchievementRule } from "@framework/types";
import { cleanUpAsset } from "@framework/exchange";

export const achievementsRulesFilter = ({
  title,
  description,
  contractId,
  item,
  achievementStatus,
  eventType,
  startTimestamp,
  endTimestamp,
}: IAchievementRule) => ({
  title,
  description,
  contractId: contractId === 0 ? null : contractId,
  item: item ? (cleanUpAsset(item) as any) : { components: [] },
  achievementStatus,
  eventType,
  startTimestamp,
  endTimestamp,
});

export const prepareAchievementsRulesInitialValues = ({
  id,
  title,
  description,
  achievementStatus,
  contractId,
  contract,
  item,
  eventType,
  startTimestamp,
  endTimestamp,
}: Partial<IAchievementRule>) => {
  return {
    id,
    title,
    description,
    achievementStatus,
    contractId,
    contract,
    item,
    eventType,
    startTimestamp,
    endTimestamp,
  };
};
